import EventDateStatus, { EventDateStatusProps } from './EventDateStatus';

export type { EventDateStatusProps };
export default EventDateStatus;
